import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M15.095 0H5.903a.66.66 0 0 0-.654.666c0 .369.294.667.657.667h9.188a.66.66 0 0 0 .655-.667.66.66 0 0 0-.655-.666m1.967 2.667H3.938C1.764 2.667 0 4.458 0 6.666v13.335C0 22.207 1.763 24 3.938 24h13.125C19.238 24 21 22.209 21 20V6.666c0-2.208-1.762-3.999-3.937-3.999m.657 8H3.28a.663.663 0 0 0-.655.667c0 .367.294.666.657.666h14.436a.66.66 0 0 0 .657-.666.66.66 0 0 0-.655-.668M5.25 8a1.323 1.323 0 0 0 1.313-1.334A1.323 1.323 0 0 0 5.25 5.334a1.323 1.323 0 0 0-1.312 1.332C3.938 7.402 4.525 8 5.25 8m10.5 0a1.323 1.323 0 0 0 1.313-1.334 1.323 1.323 0 0 0-1.313-1.332 1.323 1.323 0 0 0-1.312 1.332c0 .736.587 1.334 1.312 1.334",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }